import { render } from "./AboutPageComponent.vue?vue&type=template&id=2f1637c9&scoped=true"
import script from "./AboutPageComponent.vue?vue&type=script&lang=js"
export * from "./AboutPageComponent.vue?vue&type=script&lang=js"

import "./AboutPageComponent.vue?vue&type=style&index=0&id=2f1637c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.9.5__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1637c9"]])

export default __exports__